import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const LegendContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;

export const LegendItemContainer = styled.div<{ isFocused: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-family: Roboto;
    opacity: ${({ isFocused }) => (isFocused ? 1 : 0.25)};
    margin-bottom: 4px;
    transition: all 0.2s ease-in;
    &:first-child {
        margin-top: ${({ isFocused }) => (isFocused ? "30px" : "0")};
    }
    &:last-child {
        margin-bottom: ${({ isFocused }) => (isFocused ? "30px" : "0")};
    }
`;

export const IconWrapper = styled.div`
    margin-right: 12px;
`;

export const LabelContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

export const LabelName = styled.span<{ isFocused: boolean }>`
    font-size: ${({ isFocused }) => (isFocused ? "16px" : "14px")};
    font-weight: 500;
    width: 110px;
    color: ${colorsPalettes.carbon[500]};
    transition: font-size 0.2s ease-in;
`;

export const LabelValue = styled.span<{ color: string; isFocused: boolean }>`
    font-size: ${({ isFocused }) => (isFocused ? "16px" : "14px")};
    font-weight: 400;
    color: ${({ color }) => color};
    transition: font-size 0.2s ease-in;
`;
